import React, { useRef, useState } from "react";
import style from "./share.module.css";
import Button from "../button/Button";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
interface shareProp {
  id?: number | string;
  className?: string;
  copyText?: [string, string];
  isIcon?: boolean;
  code?: string;
  discountTitle?: string;
  discountDesc?: string;
  link?: string;
  isSpecial?: boolean;
}
const ShareBox: React.FC<shareProp> = ({
  id,
  className,
  copyText = ["لینک دعوت کپی شد!", "دعوت دوستان"],
  isIcon = true,
  code,
  discountTitle,
  link,
  discountDesc,
  isSpecial,
}) => {
  // const sendDataToGTM = useGTMDispatch();
  const inputRef = useRef<HTMLInputElement>(null);
  const [text, setText] = useState<string>(copyText[1]);

  const fullTextShare = `سلام خوبی؟ \n گردونه شانس بانی‌مد رو دیدی \n هر نفر 3 تا شانس داره! تو هم شانست رو امتحان کن: \n http://bnmod.ir/vD?id=${id} 
  `;

  const shareApi = {
    title: "banichance | Banimode",
    text: `سلام خوبی؟ \n گردونه شانس بانی‌مد رو دیدی؟ \n هر نفر 3 تا شانس داره! تو هم شانست رو امتحان کن:`,
    url: `http://bnmod.ir/vD?id=${id}`,
  };
  const codeApi = {
    title: "banichance | Banimode",
    text: `سلام خوبی؟ \n یه کد تخفیف خوب از گردونه شانس بانی‌مد بردم. من خریدامو کردم، گفتم بدمش به تو: \n ${discountTitle} : ${code} \n از لینک پایین هرچی که دوست داری انتخاب کن، بعد کدی که بهت دادم رو توی قسمت "ثبت کد تخفیف" سبد خریدت وارد کن: \n از الان مبارکه! \n`,
    url: link,
  };
  const fullTextCode = `سلام خوبی؟ \n یه کد تخفیف خوب از گردونه شانس بانی‌مد بردم. من خریدامو کردم، گفتم بدمش به تو: \n ${discountTitle}: ${code} \n ${discountDesc} \n از لینک پایین هرچی که دوست داری انتخاب کن، بعد کدی که بهت دادم رو توی قسمت "ثبت کد تخفیف" سبد خریدت وارد کن: \n از الان مبارکه! \n ${link}`;

  const changeText = function () {
    setText(copyText[0]);
    setTimeout(() => {
      setText(copyText[1]);
    }, 2000);
  };
  const handleCrossPlatform = function (type: string, value: string) {
    changeText();
    if (type === "old") {
      inputRef.current?.select();
      document.execCommand("copy");
    }
    if (type === "desktop") {
      try {
        navigator.clipboard.writeText(value);
      } catch (error) {
        inputRef.current?.select();
        document.execCommand("copy");
      }
    }
  };
  const submitShare = async function (api: any, fullText: string) {
    if (document.documentElement.clientWidth < 800) {
      if (navigator.share) {
        try {
          await navigator.share(api);
        } catch (error) {
          console.log(error);
        }
      } else {
        handleCrossPlatform("old", fullText);
      }
    } else {
      handleCrossPlatform("desktop", fullText);
    }
  };
  const handleShareApi = function () {
    // sendDataToGTM({ event: "GardoonebaniShans1402-ShareBtn" });
    if (!!code) {
      submitShare(codeApi, fullTextCode);
    } else {
      submitShare(shareApi, fullTextShare);
    }
  };
  return (
    <div className={`${style.box} ${className ? className : ""}`}>
      <Button
        text={text}
        onclick={handleShareApi}
        share={isIcon}
        isSpecial={isSpecial}
      />
      <div
        className={style.input}
        style={{
          opacity: "0",
          position: "absolute",
        }}
      >
        <input
          onClick={handleShareApi}
          ref={inputRef}
          type="text"
          readOnly
          value={id ? fullTextShare : fullTextCode}
        />
      </div>
    </div>
  );
};

export default ShareBox;
